import { isBrowser, API_URL } from "appConfiguration";

const URLClass = isBrowser ? URL : require("url").URL;

export function getApiUrl(path: string): string {
  const { href } = new URLClass(path, API_URL);
  return href;
}
